// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_TopupResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Staff topup response — Full-gated.
 * Confirms the credit operation with the new balance.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_TopupResponseDados {
franquia_id: number
request_id: string
micro_credits: number
balance_micro: number
ledger_id: number
}

export type AiCredits_TopupResponse = ApiResponse<AiCredits_TopupResponseDados>;

registerResponseContract('AiCredits_TopupResponse', {
  franquia_id:   { type: 'number',  required: true },
  request_id:    { type: 'string',  required: true },
  micro_credits: { type: 'number',  required: true },
  balance_micro: { type: 'number',  required: true },
  ledger_id:     { type: 'number',  required: true },
})
